export default __webpack_public_path__ + "static/media/background.7bdb0690.jpg";